/** @returns {boolean} */
export function isExternalFileDrag(dataTransfer) {
  if (!dataTransfer?.types) return false;
  return [...dataTransfer.types].includes('Files');
}

/** @param {DragEvent} e */
export function allowExternalFileDrop(e) {
  if (!isExternalFileDrag(e.dataTransfer)) return false;
  e.preventDefault();
  e.stopPropagation();
  e.dataTransfer.dropEffect = 'copy';
  return true;
}
